<template>
    <div>
        <v-dialog v-model="showDialog" max-width="500">
            <v-card>
            <v-card-title class="headline">{{msg}}</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo white--text" depressed @click="showDialog = false">Ok</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="emailsitem">
          <v-list-item-content class="emailsitem__99">
              <v-checkbox v-model="checkedthis"/>
          </v-list-item-content>
          <v-list-item-content class="emailsitem__1" :id="getHoverId" @click.prevent="useId()">{{email.muid}}</v-list-item-content>
          <v-list-item-content class="emailsitem__2" v-if="dashboardType == 'junk' ">
              Junk
          </v-list-item-content>
          <v-list-item-content class="emailsitem__2" v-else>
              <div v-if="orig_deleted === 2">
                  {{orig_deleted === 2 ? 'Used' : (orig_deleted === 4 ? 'Copy' : '')}}
              </div>
              <v-select
                v-else
                :items="allstatus"
                dense
                solo
                hide-details="true"
                class="select__item"
                v-model="updateStatus"
                ref="emailsitem__1"
              ></v-select>
      </v-list-item-content>
      <v-list-item-content class="emailsitem__3">
        <p  ref="email__subject" id="" v-if="dashboardType!='junk'" class="emailsitem__3--subject">
          <span @click.left.exact.prevent="showEmaiCopy(getId(),true)" @click.ctrl.prevent="showEmaiCopy(getId(),true)">{{formatString(email.email_subject)}} </span> 
          <!-- <span @click.left.exact.prevent="showEmail(getId(),false)" @click.ctrl.prevent="showEmail(getId(),true)">{{formatString(email.email_subject)}} </span>  -->
          <!-- <a :href="hrefLink" >{{ formatString(email.email_subject) }} </a> -->
        </p>
        <span v-else>{{ formatString(email.email_subject) }}</span>
         <!-- <a style="color:green; margin-top: 20px"  @click.left.exact.prevent="showEmaiCopy(getId(),false)" @click.ctrl.prevent="showEmaiCopy(getId(),true)">New Editor</a> -->
      </v-list-item-content>
      <v-list-item-content class="emailsitem__5">
        <span class="text-left">{{ formatString(email.email_from_one) }}</span>
        <span class="text-left">{{ competi_id }}</span>
      </v-list-item-content>
      <v-list-item-content class="emailsitem__6" v-if="dashboardType == 'junk'" >
        {{updateFlagName}}
      </v-list-item-content>
      <v-list-item-content class="emailsitem__6" v-else >
        <v-select
          :items="allFlags"
          dense
          solo
          hide-details="true"
          class="select__item min_width_select"
          v-model="updateFlag"
          ref="emailsitem__2"
        ></v-select>
      </v-list-item-content>
      <v-list-item-content class="emailsitem__7" v-if="dashboardType == 'junk'">
        {{updatePoints}}
      </v-list-item-content>
      <v-list-item-content class="emailsitem__7" v-else>
        <v-select
          :items="scores"
          dense
          solo
          hide-details="true"
          class="select__item min_width_select"
          v-model="updatePoints"
          ref="emailsitem__3"
        ></v-select>
      </v-list-item-content>
       <v-list-item-content class="emailsitem__9" v-if="dashboardType == 'junk'">
        {{updateMark.text}}
      </v-list-item-content>
      <v-list-item-content class="emailsitem__9" v-else>
        <v-select
          :items="readStatus"
          dense
          solo
          hide-details="true"
          class="select__item"
          v-model="updateMark"
          ref="emailsitem__4"
        ></v-select>
      </v-list-item-content>
      <v-list-item-content class="emailsitem__10">
        {{ attachment }}
      </v-list-item-content>
      <v-list-item-content class="emailsitem__8">{{
        formatDate(email.email_date)
      }}</v-list-item-content>
      <v-list-item-content class="emailsitem__4">
        <v-icon
          id="icon_style"
          @click="openPopUp()"
          data-inline="true"
          title="Peek"
          >mdi-eye</v-icon
        >
        <v-icon
          id="icon_style"
          @click="openhtmlPopUp()"
          data-inline="true"
          title="Show Html"
          >mdi-file-code</v-icon
        >
        <v-icon
          id="icon_style"
          @click="openpdfPopUp()"
          data-inline="true"
          title="Show PDF"
          >mdi-file-pdf-box</v-icon
        >
        <!-- <v-icon
          id="icon_style"
          @click="openVisualAnnotationPopUp()"
          data-inline="true"
          title="Visual Annotation"
          >mdi-wrench</v-icon
        >
        <v-icon
          id="icon_style"
          @click="textExtractionPopUp()"
          data-inline="true"
          title="Text Extraction"
          >mdi-note-text</v-icon
        > -->
      </v-list-item-content>
    </div>
    <v-divider />
  </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import _ from "lodash";
import arrow from "@/assets/img/arrow.gif";
export default {
    name: 'EmailsItem',
    data: () => ({
        readClass: "",
        isSettingUp: false,
        arrow: arrow,
        checkedthis: false,
        showDialog: false,
        msg: '',
        orig_deleted: '',
    }),
    props: [
        'email',
        'isallchecked',
    ],
    mounted() {
        var view = this, 
        e = view.email,
        refs = view.$store.getters['RawData/getEmailsItemRefs'],
        refsArr = new Array()
        // console.log(view.getId());
        // console.log(view.$refs);
        if(Object.keys(view.$refs).length !== 0){
          view.$refs.email__subject.id = parseInt(e.email_read) === parseInt(0) ? "unread" : ""
          for (var i = 1; i < 5; i++) {
              if ('emailsitem__' + i in this.$refs) {
                view.$refs['emailsitem__' + i].$refs.input.style.display = 'none'
                // view.$refs['emailsitem__' + i].$refs['input-slot'].style.maxWidth = "80%"
                view.$refs['emailsitem__' + i].$refs['input-slot'].style.padding = '0px'
              }
          }
          // let items = document.getElementsByClassName('select__item')
          // for (i = 0; i <= items.length; i++) {
          //   items[i].style.maxWidth = '80%'
          // }
          view.checkedthis = view.$store.getters['Emails/getAllChecked'] || e.muid === view.$store.getters['Emails/getCheckedByMuid'](e.muid)
          if (e.deleted === 3) {
              e.alreadycopied = true
          }
          if (refs !== null && refs.length > 0) {
              refs.forEach(function(o) {
                  refsArr.push(o.getId())
              })
          }
        }
        if (refsArr.length > 0) {
            if (!refsArr.includes(view.getId())) {
                view.$store.dispatch('RawData/setEmailsItemRefs', view)
            }
        } else {
            view.$store.dispatch('RawData/setEmailsItemRefs', view)
        }
        view.orig_deleted = view.email.deleted
        view.link = this.$router.resolve({path: '/emailEditor/' + e.muid, params: {e}, query: {data: view.email}}).href
    },
  computed: {
    updateFlagName: function(){
      let name = ''
      this.allFlags.forEach((flag)=>{
        if(flag.value == this.updateFlag){
          name = flag.text
        }
      })
      return name
    },
    dashboardType: function(){
      return this.$store.getters['RawData/getDashboardType'];
    },
    attachment: function() {
      return typeof this.email.has_attachment === 'undefined' ? 'No' : 'Yes'
    },
    competi_id: function() {
        return typeof this.email.competi_id === 'undefined' ? '' : this.email.competi_id
    },
    getHoverId: function () {
      return "hover_id";
      // return this.email.deleted === 1 ? 'hover_id' : ''
    },
    hrefLink: function () {
      let routeData = this.$router.resolve({
        path: "/email/" + this.email.muid,
      });
      return routeData.href;
    },
    allFlags: function () {
      if (
        this.$store.getters["Emails/getRequestPayload"].panelist === "producer"
      ) {
        return this.$store.getters["RawData/getAllFlags"].prod_flags;
      } else {
        return this.$store.getters["RawData/getAllFlags"].flags;
      }
    },
    // flags: function () {
    //   return JSON.parse(window.localStorage.getItem("rawData")).flags;
    // },
    scores: function () {
      var arr = new Array(),
        score = this.$store.getters["RawData/getAllScores"];
      if (
        this.$store.getters["Emails/getRequestPayload"].panelist === "producer"
      ) {
        score.prod_score.forEach(function (o) {
          arr.push({ text: o, value: o });
        });
        return arr;
      } else {
        score.score.forEach(function (o) {
          arr.push({ text: o, value: o });
        });
        return arr;
      }
    },
    allstatus: function () {
      let statuses = this.$store.getters["RawData/getAllStatus"];
      return statuses.filter((s)=>s.value!==3 && s.value!==2);
    },
    readStatus: function () {
      return this.$store.getters["RawData/getReadUnRead"];
    },
    updateFlag: {
      get: function () {
        return this.email.panelist_core;
      },
      set: function (value) {
        this.email.panelist_core = value;
        this.$store.dispatch("Emails/updateFlagByMuid", {
          muid: this.email.muid,
          panelist_core: value,
        });
      },
    },
    updatePoints: {
      get: function () {
        return this.email.panelist_score.toString();
      },
      set: function (value) {
        this.email.panelist_score = value;
        this.$store.dispatch("Emails/updatePointsByMuid", {
          muid: this.email.muid,
          panelist_score: value,
        });
      },
    },
    updateStatus: {
      set: function (value) {
        this.email.deleted = value;
        this.$store.dispatch("Emails/updateStatusByMuid", {
          muid: this.email.muid,
          deleted: value,
        });
      },
      get: function () {
        return this.getThisStatus();
      },
    },
    updateMark: {
      set: function (value) {
        this.email.email_read = value;
        this.$store.dispatch("Emails/updateMarkByMuid", {
          muid: this.email.muid,
          email_read: value,
        });
      },
      get: function () {
        return {
          text: parseInt(this.email.email_read) === 0 ? "Unread" : "Read",
          value: parseInt(this.email.email_read),
        };
      },
    },
  },
  methods: {
    useId: function () {
      var view = this;
      if (view.email.deleted === 2) {
        view
          .$fetch({
            url: view.$url("ASSIGN_COPY"),
            type: "POST",
            data: JSON.stringify({
              muid: view.email.muid,
            }),
            contentType: "application/json",
          },{
                operation: 'add',
                vueScope: view
            })
          .then(function (response) {
            if (response === null) {
              view.showDialog = true;
              view.msg = "This product does not exist.";
            } else if ("entryID" in response) {
              view.$store.dispatch("Emails/setProductId", response.entryID);
            } else if ("muid" in response) {
              view.$store.dispatch("Emails/setProductId", response.muid);
            }
          });
      }
    },
    updateStatusToCopy: function (status, copyUpdation) {
      this.email.deleted = status;
      let current_page_emails = this.$store.getters["Emails/getResponsePayload"]
      this.$store.dispatch("Emails/updateStatusByMuid", {
        muid: this.email.muid,
        deleted: status,
      });
      if(copyUpdation){
          current_page_emails.forEach((email) => {
            let selected_ids = this.$store.getters["Emails/getIdsToUpdate"]
            let selected_panelist_core = ''
            let selected_panelist_score = ''

            if(selected_ids.length > 0){
                current_page_emails.forEach(email2 => {
                  if(email2.muid === selected_ids[0]){
                    selected_panelist_core = email2.panelist_core
                    selected_panelist_score = email2.panelist_score
                  }
                })
                if(this.email.muid == email.muid && email.muid != selected_ids[0] ){
                  this.$store.dispatch("Emails/updateFlag", {
                  muid: email.muid,
                  panelist_core: selected_panelist_core,
                });
                this.$store.dispatch("Emails/updatePoints", {
                  muid: email.muid,
                  panelist_score: selected_panelist_score,
                });
              }
            }
            
          
        })
      }
      
    },
    openPopUp: function () {
      var view = this;
      window.open(
        view.$url("RENDER_HTML") + view.email.muid,
        "emailbodypopup",
        "width=800,height=500,menubar=yes"
      );
      window.focus();
      //window.open(view.$url('RENDER_HTML') + view.email.muid, '_blank');
    },
    openhtmlPopUp: function () {
      var view = this;
      window.open(
        view.$url("RENDER_PROCESSED_HTML") + view.email.muid,
        "emailhtmlpopup",
        "width=800,height=500"
      );
      window.focus();
    },
    openpdfPopUp: function () {
      var view = this;
      window.open(
        view.$url("RENDER_PDF") + view.email.muid,
        "emailpdfpopup",
        "width=800,height=500"
      );
      window.focus();
    },
    openVisualAnnotationPopUp: function () {
      var view = this;
      window.open(
        view.$url("VISUAL_ANNOTATION_URL")+"/" + view.email.muid,
        "_blank"
      );
      window.focus();
    },
    textExtractionPopUp: function(){
      var view = this;
      window.open(
        view.$url("TEXT_EXTRACTION_URL")+ view.email.muid,
        "_blank"
      );
      window.focus();
    },
    status: function (read) {
      return read === 0 ? "Unseen" : "Seen";
    },
    showEmail: function (e, newtab) {
      var view = this;
      view.email.email_read = 1;
      if (newtab === true) {
        let routeData = this.$router.resolve({
          path: "/email/" + e,
          params: { e },
          query: { data: view.email },
        });
        console.log(routeData, "rou")
        window.open(routeData.href, "_blank");
        //this.$router.push({path: '/editor/' + e, params: {e}, query: {data: view.email}})
      } else {
        console.log(e, "e")
        console.log(view.email, "edd")
        this.$router.push({
          path: "/email/" + e,
          params: { e },
          query: { data: view.email },
        });
      }
    },
    showEmaiCopy: function (e, newtab) {
      var view = this;
      view.email.email_read = 1;
      if (newtab === true) {
        let routeData = this.$router.resolve({
          path: "/emailEditor/" + e,
          params: { e },
          query: { data: view.email },
        });
        // console.log(routeData, "rou")
        window.open(routeData.href, "_blank");
        //this.$router.push({path: '/editor/' + e, params: {e}, query: {data: view.email}})
      } else {
        // console.log(e, "e")
        // console.log(view.email, "edd")
        this.$router.push({
          path: "/emailEditor/" + e,
          params: { e },
          query: { data: view.email },
        });
      }
    },
    getId: function () {
      return this.email.muid;
    },
    formatDate: function (d) {
      if (this.$store.getters["Search/getIsFromSearch"]) {
        return moment(d).format("MM/DD/YYYY hh:mm:ss a").toUpperCase();
        //return moment.unix(d).tz("UTC").format('MM/DD/YYYY hh:mm:ss a').toUpperCase()
      }
      return moment(d).format("MM/DD/YYYY hh:mm:ss a").toUpperCase();
      //return moment.unix(d).tz("UTC").format('MM/DD/YYYY hh:mm:ss a').toUpperCase()
    },
    getThisStatus: function () {
      var view = this;
      let obj = _.find(view.allstatus, function (o) {
        return parseInt(o.value) === parseInt(view.email.deleted);
      });
      if (typeof obj === "undefined") {
        return { text: "", value: "" };
      }
      return { text: obj.text, value: parseInt(view.email.deleted) };
    },
    formatString: (str) => {
      str = str.replace(/[\\]/g, "");
      str = str.replace(/[//]/g, "");
      return str;
    },
    emailSubject: function (s) {
      if (s.length > 60) {
        s = s.substring(0, 60);
        s = s + " . . .";
      }
      return s;
    },
    checkThisEmail: function (v) {
      this.checkedthis = v;
    },
  },
  watch: {
    checkedthis: function (o) {
      var view = this;
      let product_id = this.$store.getters["Emails/getProductId"];
      //console.log(view.email.deleted);
      if (product_id && o === true && view.email.deleted != 2) {
        this.updateStatusToCopy(4,true);
      } else {
        this.updateStatusToCopy(view.email.deleted, false);
      }
      if (o === true) {
        view.$store.dispatch("Emails/setUpdateObjects", {
          muid: view.email.muid,
          deleted: view.email.deleted,
          panelist_core: view.email.panelist_core,
          panelist_score: view.email.panelist_score,
          email_read: view.email.email_read,
          index_name: view.email.index_name,
          alreadycopied:
            "alreadycopied" in view.email ? view.email.alreadycopied : false,
          panelist_id: view.email.panelist_id,
        });

      } else {
        view.$store.dispatch("Emails/setUpdateAll", false).then(function () {
          return view.$store.dispatch(
            "Emails/removeObjByMuid",
            view.email.muid
          );
        });
      }
    },
  },
}
</script>
<style lang="sass" scoped>
@import "./../assets/sass/emailsitem.sass"
</style>
